import { get, post } from '@/utils/http.js'

//获取所有数据
export const  getSafeList = (data)=>post('/checklist/findtree')

// 获取编辑列表

export const getDetail = (data)=>post('/checklist/editcheck',data)

